import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section aria-labelledby="testimonios" className="bg-night" data-id="element-215" data-mp="1mzivf8h58roa">
      <div className="mx-auto max-w-page px-3 py-8 sm:px-6 sm:py-10" data-id="element-216" data-mp="1r140w8rcm3og">
        <Reveal className="text-center" data-id="element-217" data-mp="1qz9kn7r0uzqp">
          <p className="text-[0.65rem] font-extrabold uppercase tracking-[0.24em] text-volt sm:text-xs" data-id="element-218" data-mp="1d0tat7xv4t4c">
            Lo que dicen quienes ya empezaron
          </p>
          <h2 id="testimonios" className="mt-1 font-display text-xl uppercase leading-tight text-white sm:text-3xl lg:text-4xl" data-id="element-219" data-mp="1416bqsslvzeg">
            De cero a entender la lógica eléctrica
          </h2>
        </Reveal>

        <ul className="mt-5 grid gap-3 md:grid-cols-2 lg:grid-cols-3" data-id="element-220" data-mp="2ygildxg0quf5">
          {testimonials.map((item, i) => <Reveal key={item.name} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-white/10 bg-carbon p-4" data-id="element-221" data-mp="32fzr8rzcxtku" data-mpi={i}>
              <div className="flex items-center justify-between" data-id="element-222" data-mp="2q0eued2rbyfw">
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-223" data-mp="34q2pgwkci0v6">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} size={13} className="fill-volt text-volt" data-id="element-224" data-mp="2zuneqdhmwl2z" data-mpi={s} />)}
                </div>
                <QuoteIcon size={16} className="text-volt/40" aria-hidden="true" data-id="element-225" data-mp="2m0w9vieulpdl" />
              </div>
              <p className="mt-2 text-[0.8rem] leading-snug text-white sm:text-sm" data-id="element-226" data-mp="2h3w6xgdap2qp">
                “{item.text}”
              </p>
              <div className="mt-auto pt-3" data-id="element-227" data-mp="3sh8d3xwj1xg1">
                <p className="font-display text-sm uppercase text-volt" data-id="element-228" data-mp="3sggiapar83qt">
                  {item.name}
                </p>
                <p className="text-[0.7rem] text-steel sm:text-xs" data-id="element-229" data-mp="3gv5a5z428mb">
                  {item.role} · {item.place}
                </p>
              </div>
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} className="mt-5 flex justify-center" data-id="element-230" data-mp="daviyw8gkm6n">
          <CtaButton size="lg" data-id="element-231" data-mp="iaqan2025fsr">QUIERO EMPEZAR HOY DESDE CERO</CtaButton>
        </Reveal>
      </div>
    </section>;
}